import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConflictItem } from '../../../../../shared/interfaces';

@Component({
  selector: 'app-duplicates-action-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './duplicates-action-modal.component.html',
  styleUrls: ['./duplicates-action-modal.component.scss']
})
export class DuplicatesActionModalComponent implements OnInit {
  @Input() duplicatesList: ConflictItem[] = [];
  @Input() allDuplicates: boolean = false;
  
  // NUOVO: 'HASH_CONFLICT' (file identico) o 'PATH_CONFLICT' (stesso nome, contenuto diverso)
  @Input() conflictType: 'HASH_CONFLICT' | 'PATH_CONFLICT' = 'PATH_CONFLICT'; 

  selectedAction: 'replace' | 'keep' | 'ignore' = 'ignore';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    if (this.allDuplicates) {
      this.selectedAction = 'replace';
    }
  }

  // Helper utile per l'HTML: nasconde l'opzione "Mantieni" se i file sono cloni perfetti
  get canKeepBoth(): boolean {
    return this.conflictType !== 'HASH_CONFLICT';
  }

  getFileName(path: string): string {
    return path.split('/').pop() || path;
  }

  confirm() {
    this.activeModal.close(this.selectedAction);
  }
}